module.exports = __webpack_public_path__ + "static/img/dp_cloud2.15971fac.svg";